'use strict';


module.exports = function ($state, $scope, Department, Client, toast) {
    var _this = this;
    this.tipoSitio = 1;
    this.selectedClient = "";
    this.client = {};
    _this.newTasks = [];
    $scope.estado = ""

    this.getValue = function (value, row = 0, isCoord = false) {
        if (value == undefined) {
            value = "";
        }
        for (var i = 1; i <= $state.importTasks.colnumber; i++) {
            var re = new RegExp("{col".concat(i, "}"), "g");
            value = value.replace(re, $state.importTasks.data[row]["col".concat(i)])
        }
        if (isCoord && !isNaN(parseFloat(value)) && parseFloat(value) == parseInt(value)) {
            let ret = parseFloat(value);
            value = ret * 10 ** -(Math.abs(ret).toString().length - 2);
        }
        return value;
    }


    this.getClients = function (value) {
        var query = {

        };

        if (value) {
            query.filter = {
                where: {
                    name: {
                        regexp: '/^' + value + '/i'
                    }
                }
            };
        }

        return Client.find(query)
            .$promise
            .then(function (clients) {
                return clients.filter(function (client) { return client.fromImport ? false : client; });;
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    this.clientSelected = function (client) {
        this.clientId = client.id;
        _this.client.name = client.name;
        _this.client.coordinates = client.coordinates;
        _this.client.address = client.address;
        _this.client.details = client.details;
        _this.client.email = client.email;
        _this.client.phone = client.phone;
    };

    this.canNext = function () {
        if (this.selectedClient != '' && this.tipoSitio == '0')
            return true;
        if (this.tipoSitio == '1' && this.client.name && this.client.name != '')
            return true;
        return false;
    }

    this.nextStep = function () {
        // 1 Procesar Sitios
        // 2 Con id de sitio crear tareas.
        this.sitios = {}
        this.randomColor = Math.floor(Math.random() * 200) + 160;
        this.currentRow = -1;
        _this.newTasks = [];
        toast.loading("Creando Tareas...", "importTasks");
        Client.find()
            .$promise
            .then(function (clients) {
                clients.map(function (client) {
                    _this.sitios[client.name] = client.id
                });
                _this.nextRowData();
            });
    }

    this.nextRowData = function () {
        this.currentRow = this.currentRow + 1
        if (this.currentRow >= $state.importTasks.data.length) {
            //Grabo la tarea;
            var payload = {
                tasks: _this.newTasks,
                userIds: []
            };
            Department.addTasks({
                departmentId: $state.params.departmentId
            }, payload)
                .$promise
                .then(function () {
                    toast.closeLoaders("importTasks");
                    $scope.estado = "";
                    $state.reload('dashboard.departments.department.tasksAdvanced')
                        .then(function () {
                            $state.go('dashboard.departments.department.tasksAdvanced');
                        });
                    $scope.modalImport.$dismiss();
                })
                .catch(function (error) {
                    console.log(error);
                });

            return;
        }
        $scope.estado = "Procesando " + (this.currentRow + 1) + " / " + $state.importTasks.data.length;
        let tarea = $state.importTasks.data[this.currentRow]
        let task = {}
        task.name = this.getValue($state.importTasks.template.name, _this.currentRow);
        task.description = this.getValue($state.importTasks.template.description, _this.currentRow)
        task.formId = $state.importTasks.template.formId;
        task.startDate = $state.importTasks.template.startDate;
        task.endDate = $state.importTasks.template.endDate;
        task.allDay = $state.importTasks.template.allDay || false;
        task.payloadHidden = $state.importTasks.payloadHidden;
        task.repeat = false;
        task.repeatData = {};
        task.payload = [];
        $state.importTasks.template.payload.forEach(function (field) {
            task.payload.push({
                key: field,
                value: tarea[$state.importTasks.payloadCols[field]]
            });
        });
        task.color = 'hsl(' + this.randomColor + ',100%,25%)';

        if (this.tipoSitio == 0) {
            task.clientId = this.clientId;
            this.addTask(task);
        } else {
            let clientName = this.getValue(_this.client.name, _this.currentRow)
            if (this.sitios[clientName] != undefined) {
                task.clientId = this.sitios[clientName];
                this.addTask(task);
            } else {
                //Agrego Cliente Nuevo
                let coords = {
                    lng: _this.getValue(_this.client.coordinates.lng, _this.currentRow, true),
                    lat: _this.getValue(_this.client.coordinates.lat, _this.currentRow, true)
                }
                let client = {
                    name: clientName,
                    address: _this.getValue(_this.client.address, _this.currentRow),
                    details: _this.getValue(_this.client.details, _this.currentRow),
                    coordinates: coords,
                    email: _this.getValue(_this.client.email, _this.currentRow),
                    phone: _this.getValue(_this.client.phone, _this.currentRow),
                    fromImport: true
                }
                Client.upsert(client)
                    .$promise.then(function (client) {
                        _this.sitios[clientName] = client.id
                        task.clientId = _this.sitios[clientName];
                        _this.addTask(task);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }
    }

    this.addTask = function (task) {
        _this.newTasks.push(task);
        _this.nextRowData();
    }
};
